import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/quarterly-estimated-tax',
  component: () => import('../../routes/QuarterlyEstimatedTax.svelte'),
  card: {
    id: 'quarterly-estimated-tax',
    title: 'Quarterly Estimated Tax',
    description: 'Calculate quarterly estimated tax payments for self-employed individuals. Covers federal income tax, self-employment tax (Social Security + Medicare), and state income tax.',
    icon: 'calendar',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/quarterly-estimated-tax',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Quarterly Estimated Tax Calculator — Self-Employment Tax Payments',
    description: 'Free quarterly estimated tax calculator for self-employed individuals. Calculate IRS quarterly payments covering federal income tax, self-employment tax (Social Security + Medicare), and state income tax. Know exactly what to pay and when.',
  },
};

export default meta;